// @flow strict
import React from 'react';

const Kofi = () => (
  // <a href="https://ko-fi.com/huudutg" target="_blank">
  //   <img
  //     height={36}
  //     style={{ border: 0, height: 36 }}
  //     src="https://cdn.ko-fi.com/cdn/kofi3.png?v=3"
  //     alt="Buy Me a Coffee at ko-fi.com"
  //   />
  // </a>
  <a href="https://ko-fi.com/notdu" target="_blank">
    <img src="https://img.buymeacoffee.com/button-api/?text=Buy me a Coffee&nbsp&emoji=&slug=marioduarte&button_colour=FF5F5F&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" />
  </a>
);

export default Kofi;
